import { Button, useComputedColorScheme, useMantineTheme } from '@mantine/core';
import { IconEditCircle, IconPencil } from '@tabler/icons-react';
import { MRT_Row, MRT_TableInstance } from 'mantine-react-table';
import { memo } from 'react';
import { useClaimDraftStore } from 'store/ClaimDraftStore';

export const EditRowButton = memo(
  ({
    table,
    row,
    type,
    disabled = false,
  }: {
    table: MRT_TableInstance<any>;
    row: MRT_Row<any>;
    type: string;
    disabled?: boolean;
  }) => {
    const theme = useMantineTheme();
    const computedColorScheme = useComputedColorScheme('dark');
    const textColor = computedColorScheme === 'dark' ? 'white' : 'black';
    const color = theme.colors[`primary-${computedColorScheme}`][0];

    const { getEditDraftById } = useClaimDraftStore();
    const hasDraft =
      type === 'claim'
        ? getEditDraftById(row.original.id)?.id === row.original.id
        : false;

    return (
      <Button
        onClick={() => {
          table.setEditingRow(row);
        }}
        data-testid={`edit-${type}-button`}
        data-variant="edit"
        size="xs"
        disabled={disabled}
        variant="transparent"
        style={{
          color: color,
          transition: 'color 0.2s',
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = color)}
        onMouseLeave={(e) => (e.currentTarget.style.color = textColor)}
        c={textColor}
      >
        {hasDraft ? <IconEditCircle size={21} /> : <IconPencil size={21} />}
      </Button>
    );
  }
);
